/* globals CWB_API_ENV */
import React, { useEffect } from 'react';
import { Input } from 'reactstrap';
import { getI18n, Trans, withI18n } from 'react-i18next'
import { client } from "shared/apiClient";
import CWBLogoGrey from "images/icon-cwb-logo-grey.svg";
import styled, { css } from "styled-components";
import { redirectToLogin, redirectAuthenticated, checkProducerPhoneVerification } from "shared/helpers";
import { withRouter } from "react-router-dom";
import {
    CWBAPI,
    CWBLoadingCrest,
    getSessionDataFromAuthToken,
    setUserAuthToken,
} from "cwb-react";
import qs from "query-string";


const Go = ({
    location,
    t,
}) => {

    useEffect(() => {
        async function tryAutoLogin() {
            let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
            let localApi = await import(`shared/api`);
            client.api = new CWBAPI(
                { ...api.default, ...localApi.default },
                CWB_API_ENV,
                CWB_USE_MOCK_ENV
            );
            let tokenAttempt = false;
            let queryStringData = null;
            let tokenResp = null;

            const redirectToLoginWithoutKeys = () => {
                delete queryStringData.k;
                delete queryStringData.tk;
                const search = qs.stringify(queryStringData);
                redirectToLogin(search ? `?${search}` : "");
            }

            const tryCompleteAutoLogin = async (tokenResp) => {
                const authToken = tokenResp && tokenResp.data && tokenResp.data.accessToken;
                if (authToken) {
                    const decoded = getSessionDataFromAuthToken(authToken);
                    const { isProducer, redirected } = await checkProducerPhoneVerification(decoded, authToken);
                    if (redirected) {
                        return;
                    }
                    delete queryStringData.k;
                    delete queryStringData.tk;
                    redirectAuthenticated(
                        decoded.UserType,
                        decoded.WebSessionKey,
                        decoded.UserId,
                        queryStringData,
                        authToken,
                        isProducer,
                    );
                } else {
                    redirectToLoginWithoutKeys();
                }
            }

            // Step 1: obtain a token. The browser-cookie fallback only applies when the
            // bridge exchange (k / tk) itself fails, never when a later step fails.
            try {
                queryStringData = qs.parse(location.search);
                if (!queryStringData.k && !queryStringData.tk) {
                    tokenResp = await client.api.user.getAuthToken();
                } else {
                    tokenResp = await client.api.user.postBridgeAuthTokenFromSession(queryStringData.k || queryStringData.tk);
                    tokenAttempt = true;
                }
            } catch (ex) {
                if (!queryStringData) {
                    redirectToLogin(location.search);
                    return;
                }
                if (!tokenAttempt) {
                    redirectToLoginWithoutKeys();
                    return;
                }
                try {
                    tokenResp = await client.api.user.getAuthToken();
                } catch (fallbackEx) {
                    redirectToLoginWithoutKeys();
                    return;
                }
            }

            // Step 2: complete the login with the token we have. A failure here (for example
            // the producer phone check API failing) must not switch to another session.
            try {
                await tryCompleteAutoLogin(tokenResp);
            } catch (ex) {
                redirectToLoginWithoutKeys();
            }
        }

        tryAutoLogin();
    }, []);

    return (
        <StyledDiv isCWBLabs={false}>
            <CWBLoadingCrest customLogoSrc={CWBLogoGrey} />
        </StyledDiv>
    )
}
const StyledDiv = styled.div`
  ${(p) =>
        p.isCWBLabs &&
        css`
      height: calc(100% - 80px);
      background-color: #040f1c;
    `}
`;
export default withI18n()(withRouter(Go));
